import {
  Alert,
  Button,
  Collapse,
  Dropdown,
  Modal,
  Scrollspy,
  Tab,
} from "bootstrap";

window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

window.bootstrapDetectBreakpoint = function () {
  const breakpointNames = ["xxl", "xl", "lg", "md", "sm", "xs"];
  let breakpointValues = [];
  for (const breakpointName of breakpointNames) {
    breakpointValues[breakpointName] = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue("--breakpoint-" + breakpointName);
  }
  let i = breakpointNames.length;
  for (const breakpointName of breakpointNames) {
    i--;
    if (
      window.matchMedia("(min-width: " + breakpointValues[breakpointName] + ")")
        .matches
    ) {
      return breakpointName;
    }
  }
  return null;
};

document.documentElement.style.setProperty(
  "--scrollbar-width",
  window.innerWidth - document.documentElement.clientWidth + "px"
);

jQuery(document).ready(function ($) {
  //timeout required for chrome..
  setTimeout(function () {
    $('.wsf-field-wrapper[data-type="range"]').each(function () {
      let $prevItem = $(this).prev();

      //check if the custom label container is right before the slider
      if (
        $prevItem.attr("data-type") == "html" &&
        $prevItem.find(".budget-value").length
      ) {
        let tabIndex = $(this).parents(".wsf-group").index();
        let fieldIndex = $(this).index();

        //initially show value
        let value = $(this).find("input").val() - 1;
        let customLabel =
          window.wsf_form_json[1].groups[tabIndex].sections[0].fields[
            fieldIndex
          ].meta.data_grid_datalist.groups[0].rows[value].data[0];
        $prevItem.find(".budget-value").html(customLabel);

        //update on range slider change
        $(this)
          .find("input")
          .on("change", function () {
            let value = $(this).val() - 1;
            let customLabel =
              window.wsf_form_json[1].groups[tabIndex].sections[0].fields[
                fieldIndex
              ].meta.data_grid_datalist.groups[0].rows[value].data[0];
            $prevItem.find(".budget-value").html(customLabel);
          });
      }
    });
  }, 500);

  function MaxWidthContainer() {
    $(".maxwidth").each(function () {
      var maxWidth = $(this).data("maxwidth");
      if (!maxWidth) {
        maxWidth = "100vw";
      }
      $(this).css("width", maxWidth);

      var windowWidth = $(window).width();
      var offsetX = $(this).position()["left"];
      var width = $(this).width();

      $(this).css(
        "margin-left",
        offsetX * -1 + (windowWidth - width) / 2 + "px"
      );
      $(this).addClass("resized");
    });
  }

  $(window).resize(function () {
    MaxWidthContainer();
  });

  MaxWidthContainer();
});

jQuery(document).ready(function ($) {
  var initScroll = $(".initscroll");
  if (initScroll.length) {
    var bp = window.bootstrapDetectBreakpoint();
    var scrollDown = 0;
    if (bp == "xs" || bp == "sm" || bp == "md") {
      setTimeout(function () {
        $("html, body").animate(
          {
            scrollTop: initScroll.offset().top - 90,
          },
          500
        );
      }, 10);
    } else {
      setTimeout(function () {
        $("html, body").animate(
          {
            scrollTop: initScroll.offset().top - 175,
          },
          500
        );
      }, 10);
    }
  }
});
(function () {
  var throttle = function (type, name, obj) {
    var obj = obj || window;
    var running = false;
    var func = function () {
      if (running) {
        return;
      }
      running = true;
      requestAnimationFrame(function () {
        obj.dispatchEvent(new CustomEvent(name));
        running = false;
      });
    };
    // Original event is tied to a func that'll only trigger once every animation frame
    obj.addEventListener(type, func);
  };

  /* init - you can init any event */
  var bp = window.bootstrapDetectBreakpoint();
  if (bp == "xs" || bp == "sm" || bp == "md") {
  } else {
    throttle("scroll", "optimizedScroll");
  }
})();

// handle event
window.addEventListener("optimizedScroll", function () {
  let header = document.getElementById("header");
  if (typeof header !== "undefined" && header !== null) {
    var scrollTriggerHeight = document.getElementById("header").offsetHeight;
    if (window.scrollY > scrollTriggerHeight) {
      document.getElementById("header").classList.add("fixed-top");
      document.getElementById("contentbody").classList.add("scrolled");
    } else {
      document.getElementById("header").classList.remove("fixed-top");
      document.getElementById("contentbody").classList.remove("scrolled");
    }
  }
});
